// Seasonal theme window — plain module (no "use client") so it can be called
// from both Theme.ts (client) and HalloweenEffects.

// Active Oct 25 – Nov 1 each year (inclusive)
export const isHalloweenDate = (d: Date): boolean => {
  const md = d.getMonth() * 100 + d.getDate(); // month is 0-based: Oct=9, Nov=10
  return md >= 929 && md <= 1001;
};

export const isHolidayActive = () => {
  const today = new Date();
  return isHalloweenDate(today);
};
